class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.modal = this.closest(".search-modal");
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.overlay = this.querySelector(".predictive-search-overlay");
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.querySelector("form.search").addEventListener("submit", this.onFormSubmit.bind(this));
    this.querySelector('button[type="button"]').addEventListener("click", this.clear.bind(this));

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.overlay.addEventListener("click", this.onFocusOut.bind(this));

    //this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.clear();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }

  onFocus() {
    console.log(this, "onFocus");
    if (!this.parentElement.classList.contains("template-search__search")) {
      if (document.querySelector(".search-modal.modal__content.searching.hide-search-modal")) {
        document
          .querySelector(".search-modal.modal__content.searching.hide-search-modal")
          .classList.remove("hide-search-modal");
      }
      if (document.querySelector(".predictive-search.hide-predictive-search")) {
        document
          .querySelector(".predictive-search.hide-predictive-search")
          .classList.remove("hide-predictive-search");
      }
    }

    // if (document.querySelector('predictive-search button[type="button"][aria-label="Close"]')) {
    //   document.querySelector('predictive-search button[type="button"][aria-label="Close"]').classList.remove('hide-search-close-button');
    // }
    // document.body.classList.add('predictive-search--focus');

    if (document.querySelector('predictive-search button[type="button"][aria-label="Close"]')) {
      document
        .querySelector('predictive-search button[type="button"][aria-label="Close"]')
        .classList.add("hide-search-close-button");
    }

    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut(e) {
    console.log("onFocusOut");

    if (document.querySelector(".predictive-search")) {
      document.querySelector(".predictive-search").classList.add("hide-predictive-search");
      document
        .querySelector(".search-modal.modal__content.searching")
        ?.classList.add("hide-search-modal");
    }
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.clear();
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll("li");
    let activeElement = this.querySelector("li");

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const perPage = this.dataset.perPage || 4;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
    console.log(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent(
        "resources[type]"
      )}=product&section_id=predictive-search`
    );
    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent(
        "resources[type]"
      )}=product&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);

        if (this.modal) this.modal.classList.add("searching");
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]").textContent
    );
  }

  open() {
    this.overlay.style.display = "block";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    // document.body.classList.add('predictive-search--focus');
  }

  close() {
    console.log("close");
    this.overlay.style.display = "none";
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    document.body.classList.remove("predictive-search--focus");
  }

  clear() {
    this.input.value = "";
    this.removeAttribute("open");
    this.removeAttribute("results");
    if (!this.modal) this.input.focus();
  }
}

customElements.define("predictive-search", PredictiveSearch);
